import { Divider, Layout, Spin } from 'antd'
import React from 'react'
import AdminAppointmentForm from './AdminAppointmentForm'
import AdminAppointmentTabs from './AdminAppointmentTabs'
import AdminAppointmentActions from './AdminAppointmentActions'

export default function AdminAppointmentPage ({ form, appointment, setAppointment, loading, setLoading, cancel, back, delay, setIsDirty }) {
  return (
    <Layout style={{ padding: '1em', backgroundColor: 'white', marginTop: '2em', justifyContent: 'space-between' }}>
      <Spin spinning={loading} >
        { appointment &&
        <>
          <div style={{ display: 'flex', justifyContent: 'space-between' }} >
            <div style={{ flexBasis: '49%' }}>
              <AdminAppointmentForm appointment={appointment} setLoading={setLoading} form={form} />
            </div>
            <div style={{ flexBasis: '49%' }}>
              <AdminAppointmentTabs appointment={appointment} setLoading={setLoading} setAppointment={setAppointment} setIsDirty={setIsDirty} />
            </div>
          </div>
          <Divider style={{ marginTop: '0' }} />
          <AdminAppointmentActions form={form} appointment={appointment} cancel={cancel} back={back} delay={delay} />
        </>
        }
      </Spin>
    </Layout >
  )
}
